import type { SpecAttributeForScpVo } from '@/api/reportApi'

/** 必填（required === '1'）但已选编码里没有它任何一个属性值的属性名称 */
export const findUnboundRequiredAttributes = (
  attributes: SpecAttributeForScpVo[] = [],
  selectedValueCodes: string[] = [],
): string[] => {
  const selected = new Set(selectedValueCodes)
  return attributes
    .filter(
      (attribute) =>
        attribute.required === '1' &&
        !attribute.specAttributeValueForScpVOList?.some((value) =>
          selected.has(value.specAttributeValueCode),
        ),
    )
    .map((attribute) => attribute.specAttributeName)
}
import type { SpecAttributeForScpVo } from '@/api/reportApi'

/** 必填（required === '1'）但已选编码里没有它任何一个属性值的属性名称 */
export const findUnboundRequiredAttributes = (
  attributes: SpecAttributeForScpVo[] = [],
  selectedValueCodes: string[] = [],
): string[] => {
  const selected = new Set(selectedValueCodes)
  return attributes
    .filter(
      (attribute) =>
        attribute.required === '1' &&
        !attribute.specAttributeValueForScpVOList?.some((value) =>
          selected.has(value.specAttributeValueCode),
        ),
    )
    .map((attribute) => attribute.specAttributeName)
}
